import React from "react";
import { DisplayPercentage } from "components/display/percentage";

const PercentageCell = ({ getValue }) => {
  return <DisplayPercentage value={getValue()} precision={0} withSuffix={true} />;
};

export default PercentageCell;
